import { ElMessageBox } from 'element-plus';

export function showWarningAlert(message, title = '提示') {
  return ElMessageBox.alert(message, title, {
    confirmButtonText: '确认',
    type: 'warning',
    showClose: false,
    closeOnClickModal: false,
    closeOnPressEscape: false
  });
}